import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/event/index";

function loadListAPI(payload) {
  return axios.get(`/api/eh/event`, {
    params: { ...payload },
  });
}

function* loadList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });

  // yield put({
  //   type: actions.INIT_EVENT,
  // });

  try {
    const response = yield call(loadListAPI, payload);
    console.log("response: ", response);
    console.log("response.data.data.eventList: ", response.data.data.eventList);

    yield put({
      type: actions.LOAD_LIST_SUCCESS,
      payload: response.data.data.eventList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadWinnerListAPI(payload) {
  return axios.get(`/api/eh/event-winner`, {
    params: { ...payload },
  });
}

function* loadWinnerList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });
  try {
    const response = yield call(loadWinnerListAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.eventWinnerList: ",
      response.data.data.eventWinnerList
    );

    yield put({
      type: actions.LOAD_WINNER_LIST_SUCCESS,
      payload: response.data.data.eventWinnerList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadEventAPI(payload) {
  console.log("loadEventAPI", payload);
  return axios.get(`/api/eh/event/get`, {
    params: { ...payload },
  });
}

function* loadEvent({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadEventAPI, payload);
    console.log("response: ", response);
    console.log("response.data.data.event: ", response.data.data.event);

    yield put({
      type: actions.LOAD_EVENT_SUCCESS,
      payload: response.data.data.event,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadWinnerAPI(payload) {
  return axios.get(`/api/eh/event-winner/get/${payload}`);
}

function* loadWinner({ payload }) {
  console.log("payload: ============================== ", payload);

  try {
    const response = yield call(loadWinnerAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.eventWinner: ",
      response.data.data.eventWinner
    );

    yield put({
      type: actions.LOAD_WINNER_SUCCESS,
      payload: response.data.data.eventWinner,
    });
  } catch (error) {
    console.log("error: ", error);
  }
}

function loadCommentListAPI(payload) {
  return axios.get(`/api/eh/event-comment`, {
    params: { ...payload },
  });
}

function* loadCommentList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING_COMMENT,
    payload: true,
  });
  try {
    const response = yield call(loadCommentListAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.eventCommentList: ",
      response.data.data.eventCommentList
    );

    yield put({
      type: actions.LOAD_COMMENT_LIST_SUCCESS,
      payload: response.data.data.eventCommentList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING_COMMENT,
    payload: false,
  });
}

function* watchLoadEventList() {
  yield takeEvery(actions.LOAD_EVENT_LIST, loadList);
}

function* watchLoadWinnerList() {
  yield takeEvery(actions.LOAD_WINNER_LIST, loadWinnerList);
}

function* watchLoadEvent() {
  yield takeEvery(actions.LOAD_EVENT, loadEvent);
}

function* watchLoadWinner() {
  yield takeEvery(actions.LOAD_WINNER, loadWinner);
}

function* watchLoadCommentList() {
  yield takeEvery(actions.LOAD_COMMENT_LIST, loadCommentList);
}

export default function* eventSaga() {
  yield all([
    fork(watchLoadEventList),
    fork(watchLoadWinnerList),
    fork(watchLoadEvent),
    fork(watchLoadWinner),
    fork(watchLoadCommentList),
  ]);
}
